export const PARTIDAS_PAGE_SIZE = 50;
export const PARTIDAS_EXPORT_PAGE_SIZE = 1000;

export const ESTADOS_VENCIMIENTO = [
  { value: 'vencida', label: 'Vencida' },
  { value: 'critica', label: 'Crítica (hasta 30 días)' },
  { value: 'alerta', label: 'Alerta (hasta 90 días)' },
  { value: 'vigente', label: 'Vigente' },
  { value: 'sin_fecha_valida', label: 'Sin fecha válida' },
];

export const PARTIDAS_SORT_OPTIONS = [
  { value: 'fecha_vencimiento', label: 'Vencimiento' },
  { value: 'detalle', label: 'Producto' },
  { value: 'codigo_articulo', label: 'Código de artículo' },
  { value: 'proveedor', label: 'Proveedor' },
  { value: 'numero_partida', label: 'Nº de partida' },
  { value: 'cantidad_saldo', label: 'Saldo' },
];

export const IMPORT_TYPES = {
  padron_articulos: {
    label: 'Padrón de artículos',
    expectedName: 'PadronArticulos.xlsx',
    headers: [
      'CodArticulo',
      'DetalleMedida',
      'Nivel1',
      'Nivel2',
      'Nivel3',
      'Nivel4',
    ],
  },
  partidas_activas: {
    label: 'Partidas activas',
    expectedName: 'PartidasActivas.xlsx',
    headers: [
      'Nº Partida',
      'Cod Proveedor',
      'Proveedor',
      'Fecha',
      'FechaVto.',
      'Cant.Entrada',
      'Cant.Salida',
      'Cant.Saldo',
      'Estado',
      'Articulo',
      'Detalle',
    ],
  },
};

const isoDate = (date) => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const createDefaultPartidasFilters = () => {
  const today = new Date();
  const from = new Date(today);
  from.setDate(from.getDate() - 30);

  return {
    busqueda: '',
    productos: [],
    niveles: [],
    proveedores: [],
    estados: [],
    fechaDesde: isoDate(from),
    fechaHasta: `${today.getFullYear()}-12-31`,
  };
};
